import React from 'react';
import { useClient } from '../../context/ClientContext';

export default function BrandCampaign({ data }) {
  const { brand, dataSources } = useClient();
  const currencySymbol = dataSources?.googleAds?.currencySymbol || '$';

  if (!data) return null;

  const { enquiries, cost, costPerEnquiry, clicks } = data;

  return (
    <div>
      <h3 className="text-sm font-semibold text-gray-700 uppercase tracking-wide mb-4"
          style={{ fontFamily: brand.typography?.headerFont }}>
        Brand Campaign
      </h3>
      <div className="bg-white rounded-xl shadow-sm hover:shadow-md transition-all duration-200 border border-gray-100 p-6">
        <div className="flex items-center gap-2 mb-4">
          <svg className="w-5 h-5 text-gray-400" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2}
              d="M9.568 3H5.25A2.25 2.25 0 003 5.25v4.318c0 .597.237 1.17.659 1.591l9.581 9.581c.699.699 1.78.872 2.607.33a18.095 18.095 0 005.223-5.223c.542-.827.369-1.908-.33-2.607L11.16 3.66A2.25 2.25 0 009.568 3z" />
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 6h.008v.008H6V6z" />
          </svg>
          <h4 className="text-lg font-semibold text-gray-900"
              style={{ fontFamily: brand.typography?.headerFont }}>
            {brand.brandName}
          </h4>
        </div>

        <p className="text-xs text-gray-400 mb-3">People searching for your business by name</p>

        <div className="flex gap-6">
          <div>
            <p className="text-3xl font-bold" style={{ color: brand.colors?.primary }}>
              {enquiries}
            </p>
            <p className="text-sm text-gray-500">enquiries this month</p>
          </div>
          <div className="flex gap-6 items-end">
            <div>
              <p className="text-sm font-semibold text-gray-900">
                {costPerEnquiry > 0 ? `${currencySymbol}${costPerEnquiry.toFixed(0)}` : '\u2014'}
              </p>
              <p className="text-xs text-gray-500">per enquiry</p>
            </div>
            <div>
              <p className="text-sm font-semibold text-gray-900">{clicks}</p>
              <p className="text-xs text-gray-500">clicks</p>
            </div>
            <div>
              <p className="text-sm font-semibold text-gray-900">{currencySymbol}{cost.toFixed(0)}</p>
              <p className="text-xs text-gray-500">spend</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
